/* unplugin-vue-components disabled */import { render } from "./CompleteOrder.vue?vue&type=template&id=f37bb1e0&scoped=true&ts=true"
import script from "./CompleteOrder.vue?vue&type=script&lang=ts"
export * from "./CompleteOrder.vue?vue&type=script&lang=ts"

import "./CompleteOrder.vue?vue&type=style&index=0&id=f37bb1e0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37bb1e0"]])

export default __exports__